import { render, staticRenderFns } from "./ListarPerifericos.vue?vue&type=template&id=c13a3b24"
import script from "./ListarPerifericos.vue?vue&type=script&lang=js"
export * from "./ListarPerifericos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports